/**
 *
 * Asynchronously loads the component for Sap002
 * Author: Anhnt2, Minhltn
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
